import { render, staticRenderFns } from "./TqTextarea.vue?vue&type=template&id=42511bb6&scoped=true&"
import script from "./TqTextarea.vue?vue&type=script&lang=js&"
export * from "./TqTextarea.vue?vue&type=script&lang=js&"
import style0 from "./TqTextarea.vue?vue&type=style&index=0&id=42511bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42511bb6",
  null
  
)

export default component.exports